import { ParticipationCardSkeleton, SkeletonItem } from '@capsicum/common-web';
import { BuySellButtonsSkeleton } from '@capsicum/socios-core-web';

import { WalletFanTokenListCard } from '../../ui';
import { SummarySectionItem } from '../../ui/wallet-partner-details';
import { WalletCollectiblesCarouselSkeleton } from '../digital-collectibles';

import {
	PageWrapper,
	SectionCardListWrapper,
	SectionHeader,
	SectionSubtitle,
	SectionTitle,
	SectionWrapper,
	SummarySectionWrapper
} from './WalletPartnerDetails.styled';

export const BuySellButtonsSectionSkeleton = () => (
	<SectionWrapper>
		<BuySellButtonsSkeleton />
	</SectionWrapper>
);

export const CarouselSectionSkeleton = () => (
	<SectionWrapper>
		<SectionTitle>
			<SkeletonItem height={20} width={124} />
		</SectionTitle>
		<SectionCardListWrapper>
			<WalletCollectiblesCarouselSkeleton />
		</SectionCardListWrapper>
	</SectionWrapper>
);

export const CardSectionSkeleton = () => (
	<SectionWrapper>
		<SectionHeader>
			<SectionTitle>
				<SkeletonItem height={20} width={124} />
			</SectionTitle>
			<SectionSubtitle>
				<SkeletonItem height={20} width={124} />
			</SectionSubtitle>
		</SectionHeader>
		<SectionCardListWrapper>
			<ParticipationCardSkeleton />
			<ParticipationCardSkeleton />
		</SectionCardListWrapper>
	</SectionWrapper>
);

export const SummarySectionSkeleton = () => (
	<SummarySectionWrapper>
		<SummarySectionItem isLoading />
		<SummarySectionItem isLoading />
	</SummarySectionWrapper>
);

export const PageSkeleton = () => (
	<PageWrapper>
		<WalletFanTokenListCard isLoading />
		<BuySellButtonsSectionSkeleton />
		<SummarySectionSkeleton />
		<CardSectionSkeleton />
		<CarouselSectionSkeleton />
	</PageWrapper>
);
